module.exports = __webpack_public_path__ + "img/zoom_one.da66fb23.svg";